/** The environments the wizard offers, shared by the page and the infrastructure service. */
import type { Environment } from '@/types'

export const ENVIRONMENTS: Array<{ value: Environment; label: string; gov?: boolean }> = [
  { value: 'stg',        label: 'Staging' },
  { value: 'dev',        label: 'Development' },
  { value: 'qa',         label: 'Quality Assurance' },
  { value: 'uat',        label: 'UAT' },
  { value: 'demo',       label: 'Demo' },
  { value: 'production', label: 'Production' },
  { value: 'uat_usgov',  label: 'USGOV UAT', gov: true },
  { value: 'prod_usgov', label: 'USGOV Prod', gov: true },
]

export const PROD_ENVS: Environment[] = ['production', 'prod_usgov']

/** The environments the Infrastructure & Settings flow offers, in this order. Staging and Demo are read live from Azure (`LIVE_INFRA_ENVIRONMENTS`). */
export const INFRA_ENVIRONMENT_IDS: readonly Environment[] = ['stg', 'demo', 'production']
export const INFRA_ENVIRONMENTS = INFRA_ENVIRONMENT_IDS.map((id) => ENVIRONMENTS.find((env) => env.value === id) as (typeof ENVIRONMENTS)[number])
